export default __webpack_public_path__ + "static/contact-background-b59ac43cd50fd438fcd27f4aa63a17d9.jpg";